var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconToys(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2212",
    transform: "translate(-87 -336)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 39",
    cx: 31,
    cy: 31,
    r: 31,
    transform: "translate(87 336)",
    style: {
      fill: "rgba(255,115,29,.1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 27.25h23.833v-7.333H19.917V10.75h-4.584a4.539 4.539 0 0 0-4.583 4.583zm11.917 11a15.761 15.761 0 0 0 2.085-.138 11.9 11.9 0 0 0 2.04-.458V30h-8.25v7.654a11.839 11.839 0 0 0 2.063.458 15.939 15.939 0 0 0 2.062.138zm0 2.75a17.389 17.389 0 0 1-6.6-1.283 19.141 19.141 0 0 1-5.73-3.617l1.971-1.971a13.658 13.658 0 0 0 1.65 1.329 18.187 18.187 0 0 0 1.833 1.1V30H10.75A2.82 2.82 0 0 1 8 27.25V15.333a7.062 7.062 0 0 1 2.154-5.179A7.062 7.062 0 0 1 15.333 8h7.333v9.167h11.917a2.82 2.82 0 0 1 2.75 2.75v7.333a2.82 2.82 0 0 1-2.75 2.75h-5.041v6.554a18.187 18.187 0 0 0 1.833-1.1 13.658 13.658 0 0 0 1.65-1.329L35 36.1a19.14 19.14 0 0 1-5.729 3.621A17.389 17.389 0 0 1 22.667 41zm0-22z",
    transform: "translate(95 344)",
    style: {
      fill: "#ff731d"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToys);
export default __webpack_public_path__ + "static/media/icon-toys.3faa20b9.svg";
export { ForwardRef as ReactComponent };